export const DARK_MODE_MEDIA_RULE = '(prefers-color-scheme: dark)'
export const MOBILE_MODE_MEDIA_RULE = '(max-width: 1200px)'
